// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__NgE55","productName":"Table_productName__ISatm"};